import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { LoggerModule, NgxLoggerLevel } from "ngx-logger";
import { AlertComponent } from "ngx-bootstrap/alert";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { AlertModule } from "ngx-bootstrap/alert";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { NbcAlerts } from "./component/nbc-alert/nbc-alert.component";
import { NbcModalAlerts } from "./component/nbc-alert/nbc-modal-alert.component";
import { NbcSelectComponent } from "./component/nbc-select/nbc-select.component";
import { NbcBreadcrumbComponent } from "./component/nbc-breadcrumb/nbc-breadcrumb.component";
import { NbcPageSizeComponent } from "./component/pagination/page-size/page-size.component";
import { NbcPaginationLabelComponent } from "./component/pagination/label/pagination-label.component";
import { NbcPaginationComponent } from "./component/pagination/pagination/pagination.component";
import { PaginationModule, PaginationConfig } from "ngx-bootstrap/pagination";
import { InputRestrictionDirective } from "./directives/inputRestriction.directive";
import { NbcMultiSelectDropdown } from "./component/nbc-multi-select/nbc-multi-select-dropdown.component";
import { NbcFileDownloadComponent } from "./component/nbc-file-download/nbc-file-download.component";
import { NbcDropDownComponent } from "./component/nbc-dropdown/nbc-dropdown.component";
import { NbcBudgetCodeComponent } from "./component/nbc-budget-code/nbc-budget-code.component";
import { NbcAuthorizationDirective } from "./directives/nbc-authorization.directive";
import { NbcModalConfirmation } from "./component/confirmation/nbc-modal-confirmation.component";
import { ContactTypeaheadComponent } from "./component/contact-typeahead/contact-typeahead.component";
import { NbcMultiselectCalendar } from "./component/nbc-calendar-multiselect/nbc-multiselect-calendar.component";
import { NbcDecimalDirective } from "./directives/nbc-decimal.directivet";
import { NbcFormSelectComponent } from "./component/form-nbc-select/nbc-form-select.component";
import { NbcTagsComponent } from "./component/nbc-tags/nbc-tags.component";
import { AnnouncementComponent } from "../announcement/announcement.component";
import { sanitizeHtmlPipe } from "./pipe/sanitize-html.pipe";
import { NbcIdleComponent } from "./component/nbc-idle/nbc-idle.component";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { ModalModule } from "ngx-bootstrap/modal";
import { NbcRightClickOpenDirective } from "./directives/nbc-right-click-open.directive";
import { NbcDisableRightClickDirective } from "./directives/nbc-disable-right-click.directive";
import { NbcLoaderComponent } from "./component/nbc-loader/nbc-loader.component";
import { ContactFlyoverComponent } from "./component/contact-flyover/contact-flyover.component";
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({ exports: [
        NbcAlerts,
        NbcModalAlerts,
        NbcSelectComponent,
        NbcBreadcrumbComponent,
        NbcPageSizeComponent,
        NbcPaginationLabelComponent,
        NbcPaginationComponent,
        InputRestrictionDirective,
        NbcMultiSelectDropdown,
        NbcFileDownloadComponent,
        NbcDropDownComponent,
        NbcAuthorizationDirective,
        NbcModalConfirmation,
        ContactTypeaheadComponent,
        NbcMultiselectCalendar,
        NbcDecimalDirective,
        NbcBudgetCodeComponent,
        NbcTagsComponent,
        NbcFormSelectComponent,
        AnnouncementComponent,
        sanitizeHtmlPipe,
        NbcIdleComponent,
        NbcRightClickOpenDirective,
        NbcDisableRightClickDirective,
  NbcLoaderComponent,
  ContactFlyoverComponent
    ],
    declarations: [
        NbcAlerts,
        NbcModalAlerts,
        NbcSelectComponent,
        NbcBreadcrumbComponent,
        NbcPageSizeComponent,
        NbcPaginationLabelComponent,
        NbcPaginationComponent,
        InputRestrictionDirective,
        NbcMultiSelectDropdown,
        NbcFileDownloadComponent,
        NbcDropDownComponent,
        NbcAuthorizationDirective,
        NbcModalConfirmation,
        ContactTypeaheadComponent,
        NbcMultiselectCalendar,
        NbcDecimalDirective,
        NbcBudgetCodeComponent,
        NbcTagsComponent,
        NbcFormSelectComponent,
        AnnouncementComponent,
        sanitizeHtmlPipe,
        NbcIdleComponent,
        NbcRightClickOpenDirective,
        NbcDisableRightClickDirective,
      NbcLoaderComponent,
  ContactFlyoverComponent
    ], imports: [CommonModule,
        FormsModule,
        BsDropdownModule,
        PaginationModule.forRoot(),
        BsDatepickerModule.forRoot(),
        NgMultiSelectDropDownModule.forRoot(),
        TypeaheadModule.forRoot(),
        AlertModule.forRoot(),
      RouterModule,
      DragDropModule,
        LoggerModule.forRoot({
            serverLoggingUrl: "/api/logs",
            level: NgxLoggerLevel.ERROR,
            serverLogLevel: NgxLoggerLevel.OFF,
            colorScheme: [
                "yellow",
                "#F37021",
                "gray",
                "gray",
                "red",
                "red",
                "red",
            ],
        }),
        ModalModule.forRoot(),
        NgIdleKeepaliveModule.forRoot()], providers: [
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class NbcSharedModule {
    static forRoot() {
        return {
            ngModule: NbcSharedModule,
            providers: [],
        };
    }
}
